import { GameKebab } from './index'

export default function kebabFactory(): GameKebab {
    return { isFrying: false, score: 0, progress: 0, side: 0 }
}
